export default __webpack_public_path__ + "static/Charts_Hover-b55b0bceb70a45029122b13f483dcf3d.png";